export default "__VITE_ASSET__XFgSP1EM__"